import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'splash-component',
  templateUrl: './splash.component.html'
})

export class SplashComponent implements OnInit {

    constructor(private router: Router) { 
        
    }
    
    ngOnInit() {

    }    
}



// WEBPACK FOOTER //
// ./src/app/components/splash/splash.component.ts